import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import { FollowUpModel } from '../model/index';

@Injectable()
export class FollowUpClientUploadService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    // private headers = new Headers( {
    //     'Content-Type': 'application/json',
    //     'Accept': 'application/json'
    // });
    // private followUpUrl = 'api/followUp';  // URL to web api
    private url = 'api/followUpClientUpload';

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    
    private handleError(error: any): Promise<FollowUpModel> {
        //console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

    saveExcelFile(query: any): Promise<any> {
        const url = `${this.url}/saveDetails`;
        return this.http
            .post(url, $.param(query), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    changeExistingClientFollowup(param: any): Promise<any> {
        const url = `${this.url}/changeExistingClientFollowup`;
        return this.http.post(url, $.param(param), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/followUpClientUpload.service.ts